import React, { useEffect, useState } from 'react';

export interface IHeading {
	type: 'h1' | 'h2' | 'h3';
	colour?: 'primary' | 'secondary'
	className?: string;
	isCentered?: boolean;
	children?: React.ReactNode;
}

const elements = {
	h1: 'h1',
	h2: 'h2',
	h3: 'h3',
};

const Heading: React.FC<IHeading> = ({
	type = 'h1',
	children,
	className = '',
	isCentered = false,
	colour = 'secondary',
	...props
}) => {
	const [style, setStyle] = useState<string>('');

	useEffect(() => {
		const textStyle = {
			h1: `font-inter text-[34px] leading-[40px] font-semibold tracking-[-1px] text-${colour === 'primary' ? 'primary-500' : colour}`,
			h2: `font-inter text-[24px] leading-[30px] font-semibold tracking-[-1px] text-${colour === 'primary' ? 'primary-500' : colour}`,
			h3: `font-inter text-[18px] leading-[26px] font-semibold tracking-[-1px] text-${colour === 'primary' ? 'primary-500' : colour}`,
		};

		setStyle(`${textStyle[type]}`);
	}, [type, colour]);

	return React.createElement(
		elements[type],
		{
			className: `${style} ${className} ${isCentered ? 'text-center' : ''}`,
			...props,
		},
		children
	);
};

export default Heading;
